import { render, staticRenderFns } from "./PurchaserDetail.vue?vue&type=template&id=47418beb&scoped=true"
import script from "./PurchaserDetail.vue?vue&type=script&lang=js"
export * from "./PurchaserDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaserDetail.vue?vue&type=style&index=0&id=47418beb&prod&lang=scss"
import style1 from "./PurchaserDetail.vue?vue&type=style&index=1&id=47418beb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47418beb",
  null
  
)

export default component.exports